import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  primary: "#0760ad",
  primaryLight: "#098a48",
  secondary: "#118a94",
  white: "#FFFFFF"
};

const HealthPackagesHero = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0760ad] to-[#098a48] py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Individual Health Packages
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Personalized care designed for your unique health needs
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default HealthPackagesHero;